export const sendEventToGTM = (event: string, params?: Object) => {
  (window as any).dataLayer?.push({
    event,
    ...params,
  });
};
